import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy',
})
export class OrderBy implements PipeTransform {
    transform(array: any[], field: string): any[] {
        const properties = field.split('.');
        return array.sort((a: any, b: any) => {
            const [fieldA, fieldB] = [a, b].map((obj) =>
                this.fetchNestedProperties(obj, properties)
            );

            if (fieldA > fieldB) {
                return 1;
            } else if (fieldA < fieldB) {
                return -1;
            } else {
                return 0;
            }
        });
    }

    fetchNestedProperties(obj: any, properties: string[]) {
        if (properties.length === 1) return obj[properties[0]];
        else if (properties.length === 0) return obj;
        else return this.fetchNestedProperties(obj[properties[0]], properties.slice(1));
    }
}
